import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, Redirect } from 'react-router-dom';
import { propTypes } from 'react-currency-input';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPerguntasConselhoMunicipal, fetchEnquetesRespostas, fetchNomeCidade, postEnquetesVotar,
} from '../../api/endpoints';
import { selecionarArquivo } from '../../app/slices/arquivosSlice';
import { selectLogin } from '../../app/slices/loginSlice';
import { abrirModalArquivo, abrirModalImpressaoSic } from '../../app/slices/modalSlice';
import {
  Divisor, Grid, Linha, ListaItem, ListaItemBody, ListaItemHeader, Alerta, Centro, ContainerJanela, FormFooter, LabelEnquete,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import FormControl from '../FormControl/FormControl';
import GridBotao from '../GridBotao/GridBotao';
import Carregar from '../Carregar/Carregar';
import { LinhaForm, LinhaForm2 } from '../FormControl/FormControlEstilo';
import { JanelaEnquete, TituloEnquete } from './ListaEnqueteEstilo';
import { ReactComponent as ArrowUp } from '../../assets/icons/arrow-up.svg';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow-down.svg';

/* eslint linebreak-style: ["error", "windows"] */

const defaultValues = {
  IdEnquete: '',
  IdResposta: '',
};

const ListaEnquete = ({
  id, campo, funcaoExibiLoader,
}) => {
  const [pergunta, setPergunta] = useState(null);
  const [listaRespostas, setListaRespostas] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [aberto, setAberto] = useState(false);
  const alert = useAlert();
  const [carregando, setCarregando] = useState(false);
  const dispatch = useDispatch();

  const dadosLogin = useSelector(selectLogin);

  const history = useHistory();

  useEffect(() => {
    Promise.all([
      fetchPerguntasConselhoMunicipal(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPergunta(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });
  }, [dadosLogin]);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  const realizarVoto = async () => {
    const resposta = await postEnquetesVotar({
      ...values,
      IdEnquete: id,
    });

    if (resposta.Error === 'Voce ja votou nessa enquete.') {
      return alert.error('Você já votou nessa enquete.', { timeout: 5000 });
    }

    if (resposta.Error) {
      return alert.error('Por favor, selecione uma das alternativas para realizar o voto.', { timeout: 5000 });
    }

    setValues(defaultValues);

    funcaoExibiLoader();

    Promise.all([
      fetchPerguntasConselhoMunicipal(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPergunta(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });

    return alert.success('Voto computado.', { timeout: 5000 });
  };

  return (
    <>
      { (pergunta) && (
      <ListaItem>
        <ListaItemHeader onClick={() => setAberto(!aberto)}>
          <Linha style={{ alignSelf: 'center', paddingRight: 5 }}>
            <span style={{ marginRight: 10, fontSize: 17, padding: 10 }}>
              {campo}
            </span>
          </Linha>

          <span style={{ maxWidth: 300, alignSelf: 'center' }}>
            {(aberto) ? (
              <ArrowDown height={13} width={13} />
            ) : (
              <ArrowUp height={13} width={13} />
            )}
          </span>
        </ListaItemHeader>
        {aberto && (
        <ListaItemBody>
          <Linha>
            <b>Escolha uma alternativa: </b>
          </Linha>

          <Divisor size="ultraPequeno" />

          <form>
            {listaRespostas && listaRespostas.filter((resposta) => resposta.IdEnquete === id).map((respostas) => (
              <div key={respostas.Id}>
                <LinhaForm>
                  <LabelEnquete htmlFor={`inputResposta${respostas.Id}`}>
                    <input
                      type="radio"
                      name="respostaEnquete"
                      value={respostas.Id}
                      id={`inputResposta${respostas.Id}`}
                      onChange={() => setVal('IdResposta', respostas.Id)}
                    />
                    {respostas.Campo}
                  </LabelEnquete>
                </LinhaForm>

                <Divisor />
              </div>
            ))}

            <LinhaForm2>
              <FormControl
                label="Sugestão: "
                value={values.Sugestao}
                onChange={({ target }) => setVal('Sugestao', target.value)}
                tamanhoFlex={3}
                type="textarea2"
                maxLength={4000}
              />
            </LinhaForm2>

            {(listaRespostas.filter((resposta) => resposta.IdEnquete === id).length === 0) ? (
              <>
                <p>Nenhuma resposta cadastrada.</p>
                <Botao
                  label="Votar"
                />
              </>
            ) : (
              <Botao
                label="Votar"
                onClick={realizarVoto}
              />
            )}
          </form>

        </ListaItemBody>
        )}
      </ListaItem>
      )}

      <Divisor />
    </>
  );
};

ListaEnquete.propTypes = {
  id: PropTypes.string,
  campo: PropTypes.string,
  funcaoExibiLoader: PropTypes.func,
};

ListaEnquete.defaultProps = {
  id: '',
  campo: '',
  funcaoExibiLoader: '',
};

export default ListaEnquete;
